const getInitialState = () => ({
    updatedAt: 0,
    settings: {},
    ratingCodes: [],
    resultPoolRequestIds: [],
    dePseudonymResults: [],
    dePseudonymResultIds: [],
    openRequests: [],
    failedRequests: [],
});

export default {
    getInitialState
};
